import { useState } from "react";
import { faqs } from "@/mocks/articles";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="w-full">
      <div className="mx-auto max-w-3xl">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl font-700 text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于鉴定标准、结论更新与线索投稿的说明。</p>
        </div>

        <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {faqs.map((item, idx) => {
            const active = open === idx;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpen(active ? null : idx)}
                    aria-expanded={active}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                  >
                    <span className="font-heading text-sm font-600 text-foreground-950 md:text-base">{item.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        active ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={active ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                </h3>
                {active && (
                  <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{item.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}